const driverLicenseEmployeeExaminersLimit = 5;

export default driverLicenseEmployeeExaminersLimit;
